<template>
  <v-dialog
    max-width="80.0rem"
    v-model="openBox"
    @keydown.esc="openBox = false"
    :persistent="true"
  >
    <div v-if="receiver" class="m-top">
      New Message
      <v-icon @click="openBox = false" class="icon-reject">mdi-close</v-icon>
    </div>
    <div class="message-box-wrapper">
      <div class="message-box">
        <div align="left">
          To :
          <v-chip small
            ><v-avatar color="#fe9d00"
              ><v-icon size="20" color="#fff">mdi-account</v-icon></v-avatar
            ><b>{{ receiver_name }}</b></v-chip
          >
        </div>
        <div style="margin-top: 2.0rem !important;">
          <v-combobox
            solo
            outline
            placeholder="Subject"
            v-model="subject"
            :items="subjects"
            item-text="job_title"
            item-value="job_title"
          >
          </v-combobox>
        </div>
        <div align="left">
          <quill-editor
            ref="myTextEditor"
            v-model="content"
            :options="editorOption"
          >
          </quill-editor>
          <div
            align="left"
            style="color: var(--button-delete-color); margin-top: 1.0rem"
            v-if="emptyText"
          >
            *Can not send empty message
          </div>
        </div>
        <div class="row" style="margin-top: 2.0rem !important;">
          <div class="col-6 no-padding">
            <div v-if="!candidate" class="row">
              <span>
                <v-checkbox
                  v-model="use_company_name"
                  :ripple="false"
                ></v-checkbox>
              </span>
              <span class="current_label"
                >Use company name to send messages</span
              >
            </div>
          </div>
        </div>
        <div class="row justify-content-end" style="text-align: right; padding: 1.2rem 0">
            <button @click="openBox = false" class="btn btn-cancel">
              Cancel
            </button>
            <button
              @click="sendMessage"
              style="margin-left: 1.0rem"
              class="btn btn-save"
            >
              Send
            </button>
          </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "message-box",
  components: {
    quillEditor
  },
  props: {
    open: Boolean,
    receiver: Object,
    jobId: String,
    candidate: Boolean,
    subLists: Array,
    selectedSubject: String
  },
  data: function() {
    return {
      receiver_id: null,
      receiver_name: null,
      job_id: this.jobId || null,
      openBox: this.open,
      subject: "",
      subjects: [],
      content: ``,
      editorOption: {
        placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            ['link'],
            [{ list: "ordered" }, { list: "bullet" }],
          ]
        }
      },
      use_company_name: true,
      emptyText: false
    };
  },
  methods: {
    filterContent: function() {
      const self = this;
      let text = self.content.trim();
      text = text.replace(/script/gi, "");
      return text;
    },
    sendMessage() {
      const self = this;
      if (self.content.length > 0) {
        let data = {
          receiver_id: self.receiver_id,
          receiver_name: self.receiver_name,
          body: self.filterContent(),
          allow_my_name: !self.use_company_name
        };
        if (self.candidate) delete data.allow_my_name;
        if (self.use_company_name && !self.candidate) {
          let user = self.$constants.getOwnerInfo();
          data.company_id = user.company_id;
        }
        if (self.job_id) data.job_id = self.job_id;
        if (self.subject) {
          if (typeof self.subject === "object") {
            data.subject = self.subject.job_title;
          } else {
            data.subject = self.subject;
          }
        }
        self.$emit("send-message", data);
      } else {
        self.emptyText = true;
      }
    }
  },
  mounted() {
    const self = this;
    if (self.subLists) {
      self.subjects = self.subLists;
    }
    if (self.selectedSubject) {
      self.subject = self.selectedSubject;
    }
    if (self.receiver) {
      if (self.candidate) {
        self.receiver_name = self.receiver.company_name;
        self.receiver_id = self.receiver.user_id;
      } else {
        self.receiver_name = self.receiver.user_name;
        self.receiver_id = self.receiver.person_id || self.receiver.user_id;
      }
    }
  },
  watch: {
    content(val) {
      if (val && val.length > 0) {
        this.emptyText = false;
      }
    }
  }
};
</script>

<style scoped>
/*.t-box{*/
/*position: absolute !important;*/
/*top: 0;*/
/*right: 0;*/
/*}*/
.message-box-wrapper {
  background-color: #ffffff;
  max-height: 80vh;
  overflow-y: scroll;
  padding: 2rem;
}
.message-box {
}
.icon-reject {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 4rem;
  color: rgba(0, 0, 0, 0.32);
}
.m-top {
  position: relative;
  background-color: #efeff4;
  color: #050505;
  font-size: 2rem;
  text-align: left;
  padding: 1rem 1rem 1rem 2rem;
}
.test {
  text-align: left;
  line-height: normal;
  font-size: 1.4rem;
}
.current_label {
  margin-left: -0.4rem;
  padding-top: 2rem;
  font-size: 1.4rem;
  color: #3d4249;
}
</style>
